import { createContextLocalStore } from '@/stores/local/createContextLocalStore';

import { OrganizationPageDocumentsAnalyzeResultStore } from './OrganizationPageDocumentsAnalyzeResultStore';

export * from './OrganizationPageDocumentsAnalyzeResultStore';

export const {
  Provider: OrganizationPageDocumentsAnalyzeResultStoreProvider,
  useStore: useOrganizationPageDocumentsAnalyzeResultStore,
} = createContextLocalStore(OrganizationPageDocumentsAnalyzeResultStore);
